import React from "react";
import { useNavigate } from "react-router-dom";
import whiteLogo from "@/assets/logos/internal/WaytoraWhiteTextLogo.svg";

interface HeaderProps {
  showHomeButton?: boolean;
  showContactButton?: boolean;
  showAboutButton?: boolean;
  showGetStartedButton?: boolean;
  isComingSoon?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  showHomeButton = false,
  showContactButton = false,
  showAboutButton = false,
  showGetStartedButton = false,
  isComingSoon = false,
}) => {
  const navigate = useNavigate();

  return (
    <header className="relative z-20 w-full p-4 sm:p-6">
      <nav className="flex items-center justify-between w-full">
        <div className="flex-1">
          {showHomeButton && (
            <button
              onClick={() => navigate("/")}
              className="group relative bg-transparent px-3 sm:px-5 py-2 text-sm sm:text-lg font-medium text-white 
              overflow-hidden rounded-lg border border-white/30 backdrop-blur-sm
              hover:border-white/50 hover:scale-105 transition-all duration-300 ease-out"
              aria-label="Go to home page"
            >
              <span className="relative z-10">Home</span>
              <div
                className="absolute inset-0 h-full w-full translate-y-full bg-white/10
                group-hover:translate-y-0 transition-transform duration-300 ease-in-out"
              ></div>
            </button>
          )}
          {showAboutButton && (
            <button
              onClick={() => navigate("/about")}
              className="group relative bg-transparent px-3 sm:px-5 py-2 text-sm sm:text-lg font-medium text-white 
              overflow-hidden rounded-lg border border-white/30 backdrop-blur-sm
              hover:border-white/50 hover:scale-105 transition-all duration-300 ease-out"
              aria-label="Go to About page"
            >
              <span className="relative z-10">About</span>
              <div
                className="absolute inset-0 h-full w-full translate-y-full bg-white/10
                group-hover:translate-y-0 transition-transform duration-300 ease-in-out"
              ></div>
            </button>
          )}
        </div>

        <div className="flex-1 flex justify-center">
          <img src={whiteLogo} alt="Waytora" className="h-10 sm:h-16 w-auto" />
        </div>

        <div className="flex-1 flex justify-end">
          {showContactButton && (
            <button
              onClick={() => navigate("/contact")}
              className="group relative bg-transparent px-3 sm:px-5 py-2 text-sm sm:text-lg font-medium text-white 
              overflow-hidden rounded-lg border border-white/30 backdrop-blur-sm
              hover:border-white/50 hover:scale-105 transition-all duration-300 ease-out"
              aria-label="Contact"
            >
              <span className="relative z-10">Contact</span>
              <div
                className="absolute inset-0 h-full w-full translate-y-full bg-white/10
                group-hover:translate-y-0 transition-transform duration-300 ease-in-out"
              ></div>
            </button>
          )}

          {showGetStartedButton && !isComingSoon && (
            <button
              onClick={() => navigate("/lodge")}
              className="group relative bg-transparent px-3 sm:px-5 py-2 text-sm sm:text-lg font-medium text-white 
              overflow-hidden rounded-lg border border-white/30 backdrop-blur-sm
              hover:border-white/50 hover:scale-105 transition-all duration-300 ease-out"
              aria-label="Create Your Trip"
            >
              <span className="relative z-10">Get Started</span>
              <div
                className="absolute inset-0 h-full w-full translate-y-full bg-white/10
                group-hover:translate-y-0 transition-transform duration-300 ease-in-out"
              ></div>
            </button>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
